export default {
    langzh: "简体中文",
    langen: "English Language",
    i18n: "English",
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    last7Days: "Past Seven Days",
    nearly1month: "Nearly one month",
    nearly3months: "Nearly three months",
    next7Days: "Next 7 Days",
    nextMonth: "Next One Month",
    next3Months: "Next One Month",
    year: "Year",
    month: "Month",
    day: "Day"
}